import { WarningCircle } from "@phosphor-icons/react";
import { m } from "@plannello/i18n/messages";
import { cx } from "@/lib/cx";
import { Button } from "./Button";

/** Error shown where the failure happened (next to the field or row, or in place of a list). */
export function InlineError({
  message,
  onRetry,
  retryLabel,
  isRetrying,
  className,
}: {
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
  isRetrying?: boolean;
  className?: string;
}) {
  return (
    <div
      role="alert"
      className={cx(
        "flex flex-wrap items-center gap-x-3 gap-y-2 rounded-control border border-danger-soft-fg/30 bg-danger-soft px-3 py-2 text-sm text-danger-soft-fg",
        className,
      )}
    >
      <WarningCircle size={16} weight="fill" aria-hidden="true" className="shrink-0" />
      <span className="min-w-0 flex-1">{message}</span>
      {onRetry ? (
        <Button size="sm" variant="secondary" onPress={onRetry} isPending={isRetrying}>
          {retryLabel ?? m.common_retry()}
        </Button>
      ) : null}
    </div>
  );
}
